module.exports = __webpack_public_path__ + "d0f16c22e0da3a977cc75a3d919893a1.png";